module.exports = __webpack_public_path__ + "img/1.42351781.jpg";